
import Vue, { PropType } from 'vue'
import Opz2Icon from './Opz2Icon.vue'
import { Sort, num, paginate, sorted } from './model'

export interface Column {
    label: string
    key?: string
    cls?: string
    /** класс ячеек, если отличается от заголовка (например, num value-indigo) */
    cellCls?: string
    width?: number
}

let uid = 0

export default Vue.extend({
    name: 'Opz2Table',
    components: { Opz2Icon },
    props: {
        caption: { type: String, required: true },
        columns: { type: Array as PropType<Column[]>, required: true },
        rows: { type: Array as PropType<any[]>, required: true },
        /** 0 — без пагинации */
        pageSize: { type: Number, default: 0 },
        unit: { type: String, default: 'записей' },
        emptyLabel: { type: String, default: 'Записей не найдено' },
        tableClass: { type: String, default: '' },
        colgroup: { type: Array as PropType<string[] | null>, default: null },
        rowClass: { type: Function as PropType<((row: any) => string) | null>, default: null },
        cellClassFn: {
            type: Function as PropType<((col: Column, row: any) => string) | null>,
            default: null,
        },
    },
    data: () => ({ sort: null as Sort | null, page: 1, id: ++uid }),
    computed: {
        sortable(): Column[] {
            return this.columns.filter(col => col.key)
        },
        sized(): boolean {
            return this.columns.some(col => col.width)
        },
        weight(): number {
            return this.columns.reduce((sum, col) => sum + (col.width || 100), 0)
        },
        view(): ReturnType<typeof paginate> {
            const rows = sorted(this.rows, this.sort)
            return this.pageSize
                ? paginate(rows, this.page, this.pageSize)
                : paginate(rows, 1, Math.max(rows.length, 1))
        },
    },
    watch: {
        // новый расчёт — с первой страницы, как в макете
        rows() {
            this.page = 1
        },
    },
    methods: {
        num,
        plain(label: string) {
            return label.replace(/<br\s*\/?>/g, ' ').replace(/<[^>]+>/g, '')
        },
        headStyle(col: Column) {
            return this.sized ? { width: `${(((col.width || 100) / this.weight) * 100).toFixed(3)}%` } : null
        },
        sortOf(col: Column) {
            if (!this.sort || this.sort.field !== col.key) return null
            return this.sort.dir === 1 ? 'ascending' : 'descending'
        },
        toggleSort(field: string) {
            const old = this.sort
            this.sort = { field, dir: old && old.field === field ? (-old.dir as 1 | -1) : 1 }
        },
        onMobileSort(field: string) {
            this.sort = field ? { field, dir: 1 } : null
        },
        cellClass(col: Column, row: any) {
            return (
                [col.cellCls || col.cls, this.cellClassFn ? this.cellClassFn(col, row) : '']
                    .filter(Boolean)
                    .join(' ') || null
            )
        },
        rowKey(row: any, index: number) {
            return row.id ?? row.staffId ?? row.day ?? index
        },
    },
})
